import { useRemoteConfig } from '../../../module/remote-config'
import { useStore } from '../../models'

type ConvexEnabledResult =
  | {
      enabled: true
      mode: 'prompt' | 'default'
    }
  | {
      enabled: false
    }

export const useIsConvexEnabled = (): ConvexEnabledResult => {
  const {
    session: { user }
  } = useStore()

  const convexConfig = useRemoteConfig((state) => state.convex_config)

  if (convexConfig.shouldPromptForConvexGame && user?.userRoles?.includes('admin')) {
    return {
      enabled: true,
      mode: 'prompt'
    }
  }

  if (convexConfig.isConvexPracticeGamesEnabled) {
    return {
      enabled: true,
      mode: 'default'
    }
  }

  return {
    enabled: false
  }
}
